export const updateModalVisible = (actionType, open, disableScroll = true) => {
    if (disableScroll)
        document.body.style.overflow = open ? 'hidden' : 'unset';

    return { type: actionType, payload: open }
};
